import React, { useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { breakpoints } from "../../../theme"

const Wrapper = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 14px;
  line-height: 152.9%;
  user-select: none;
  color: var(--font-color);
  > * {
    margin: 15px;
  }
  @media (min-width: ${breakpoints.medium}px) {
    font-size: 16px;
  }
`

const StyledRadioButton = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const NewRadioButton = styled.span`
  display: inline-block;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: #fff;
  border: 1px black solid;

  ${props => {
    if (props.isChecked) {
      return `
    &:before {
      content: "";
      display: block;
      background: black;
      transform: translate(3px, 3px);
      width: 7px;
      height: 7px;
      border-radius: 50%;
    }
`
    }
  }}
`

function RadioButton({ field, ...props }) {
  const [isChecked, setIsChecked] = useState(false)
  return (
    <Wrapper>
      <StyledRadioButton
        id="radiobutton"
        type="checkbox"
        {...field}
        {...props}
        onChange={() => {
          setIsChecked(!isChecked)
        }}
      />
      <NewRadioButton isChecked={isChecked} aria-hidden="true" />
      <span>{props.title}</span>
    </Wrapper>
  )
}

RadioButton.propTypes = {
  title: PropTypes.string,
}

export { RadioButton }
